export default __webpack_public_path__ + "static/media/b001Zinc.42259bbe.jpg";